import script from "./ImageIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageIcon.vue?vue&type=script&setup=true&lang=js"

import "./ImageIcon.vue?vue&type=style&index=0&id=63d440c1&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63d440c1"]])

export default __exports__